import getters from './getters'
import mutations from './mutations'
import actions from './actions'
const state = {
  siteList: '',
  serviceProviderList: '',
  rateList: '',
  siteDetails: ''
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}


// WEBPACK FOOTER //
// ./src/store/modules/siteManagement/index.js